import { render, staticRenderFns } from "./SystemCard.vue?vue&type=template&id=f3445f9a&scoped=true"
import script from "./SystemCard.vue?vue&type=script&lang=ts"
export * from "./SystemCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3445f9a",
  null
  
)

export default component.exports